import React from "react";
import Link from "gatsby-link";
import Checkbox from "../Checkbox";
import "swiper/dist/css/swiper.min.css";
import "../../pages/index.styl";
import "./Login.styl";
import LoadingOverlay from "react-loading-overlay";
import Help from "./Help";
import Cookies from "js-cookie";
import { redirectToSignup } from "../../utils/NavigationUtils";

class LoginATI extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userName: "",
      password: "",
      admin: false,
      rememberme: "",
      action: "",
      errorMessage: "",
      success: false,
      redirect: "",
      isActive: false,
      adminErrors: [],
      adminState: "",
      help: props.help,
      source: props.source,
    };
  }

  handleUpdate = (event) => {
    if (event.target.checked) {
      this.setState({ admin: true });
    } else {
      this.setState({ admin: false });
    }
  };

  updateUsername = (event) => {
    this.setState({ userName: event.target.value });
  };

  updatePassword = (event) => {
    this.setState({ password: event.target.value });
  };

  postData = (url) => {
    // Default options are marked with *
    return fetch(url, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, cors, *same-origin
      //cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      //credentials: "same-origin", // include, *same-origin, omit
      headers: {
        //"Content-Type": "text/html",
        //"Accept" : "text/html"//,
        //  "Accept-Encoding": "gzip, deflate"
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body:
        "j_username=" +
        encodeURIComponent(this.state.userName) +
        "&j_password=" +
        encodeURIComponent(this.state.password) +
        "&portal=true",
    }).then((response) => response.json()); // parses response to JSON
  };

  postDataAgentAdmin = (url) => {
    // Default options are marked with *
    return fetch(url, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, cors, *same-origin
      //cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      //credentials: "same-origin", // include, *same-origin, omit
      headers: {
        //"Content-Type": "text/html",
        //"Accept" : "text/html"//,
        //  "Accept-Encoding": "gzip, deflate"
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body:
        "userName=" + this.state.userName + "&password=" + this.state.password,
    }).then((response) => response.json()); // parses response to JSON
  };

  handleSubmit = (event) => {
    if (this.state.admin) {
      this.setState({ isActive: true });
      event.preventDefault();
      this.setState({ isActive: true });
      this.postDataAgentAdmin("/agentadmin/login").then((data) => {
        // console.log("data: " + JSON.stringify(data));
        let errorString = null;
        let successValue = false;
        if (data.errors != null && data.errors[0] != null) {
          errorString = data.errors[0];
        }
        if (data.messageKey != null && data.messageKey === "success") {
          successValue = true;
        }
        this.setState({
          errorMessage: errorString,
          success: successValue,
          redirect: "/agentadmin/agent",
          isActive: successValue,
        });
      });
    } else {
      event.preventDefault();
      this.setState({ isActive: true });
      this.postData("/wbe/CommandServlet?command=login&login=wbe").then(
        (data) => {
          // console.log(JSON.stringify(data));
          let redirCookie = Cookies.get("ATIWBEDIRECT");
          let redirectLink = data.data.redirect;
          if (redirCookie) {
            redirectLink = redirectLink + "/" + redirCookie;
          }
          this.setState({
            errorMessage: data.data.errorMessage,
            success: data.data.success,
            redirect: redirectLink,
            isActive: data.data.success,
          });
        }
      );
    }
  };

  renderRedirect = () => {
    if (this.state.success) {
      window.location.replace(this.state.redirect);
    }
  };

  renderHelpLabel = () => {
    if (this.state.source === "index") {
      return (
        <Link to="./help">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 15 15"
            width={15}
            height={15}
            fill="#E21E32"
            style={{ marginRight: 6 }}
          >
            <path
              d="M727.8 1042.6l-.7.4-.8.9.3.2.5-.5.1.1-.1.7-1.1 3.1-.2 1c0 .4.3.6.7.5l.7-.4.6-.7-.3-.3-.4.4-.1-.1.2-.7 1.1-3.1.2-1c-.1-.4-.3-.6-.7-.5zm1.5-1.5c-.2.4-.7.6-1.1.4-.4-.2-.6-.7-.4-1.1.2-.4.6-.5.9-.4.5.2.7.7.6 1.1zm-1.8 9.9a6.5 6.5 0 1 0 0-13 6.5 6.5 0 1 0 0 13m0 1c-4.1 0-7.5-3.4-7.5-7.5s3.4-7.5 7.5-7.5 7.5 3.4 7.5 7.5-3.4 7.5-7.5 7.5z"
              transform="translate(-720 -1037)"
            />
          </svg>
          Help?
        </Link>
      );
    } else {
      return (
        <a
          href="#0"
          className="header-form__label"
          onClick={() => {
            this.toggleHelp();
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 15 15"
            width={15}
            height={15}
            fill="#E21E32"
            style={{ marginRight: 6 }}
          >
            <path
              d="M727.8 1042.6l-.7.4-.8.9.3.2.5-.5.1.1-.1.7-1.1 3.1-.2 1c0 .4.3.6.7.5l.7-.4.6-.7-.3-.3-.4.4-.1-.1.2-.7 1.1-3.1.2-1c-.1-.4-.3-.6-.7-.5zm1.5-1.5c-.2.4-.7.6-1.1.4-.4-.2-.6-.7-.4-1.1.2-.4.6-.5.9-.4.5.2.7.7.6 1.1zm-1.8 9.9a6.5 6.5 0 1 0 0-13 6.5 6.5 0 1 0 0 13m0 1c-4.1 0-7.5-3.4-7.5-7.5s3.4-7.5 7.5-7.5 7.5 3.4 7.5 7.5-3.4 7.5-7.5 7.5z"
              transform="translate(-720 -1037)"
            />
          </svg>
          Help?
        </a>
      );
    }
  };

  displayHelp = () => {
    if (this.state.help === "show") {
      return <Help id="help" />;
    }
  };

  toggleHelp = () => {
    if (this.state.help === "show") {
      this.setState({ help: "hide" });
    } else {
      this.setState({ help: "show" });
    }
  };

  rendorVertialLogin = () => {
    let sessionCookie = Cookies.get("ATIWBESESSION");
    if (sessionCookie) {
      return this.renderATIConnectButton();
    } else {
      return (
        <div style={{ width: "100%" }}>
          {this.renderRedirect()}
          <LoadingOverlay
            active={this.state.isActive}
            spinner
            text="Loading..."
          >
            <div style={{ marginTop: 50, display: "flex", justifyContent: "center", alignContent: "center", alignItems: "flex-start", flexWrap: "wrap", backgroundColor: "rgba(0, 48, 78, .8)"}}>
              <div class="ws__lists" style={{ marginTop: 35, paddingLeft: 70, paddingRight: 50, display: "inherit", height: "auto", flexBasis: "33%", flexGrow: 1}}><ul class="t-ul"><li>Access our industry leading booking platform where you can easily design your customer's next American road trip!</li><li>Unbeatable rates - all products and services are directly contracted</li><li>Discover ATI's curated Drive America packages - get ready to hit the road!</li></ul></div>
                <div style={{ textAlign: "center", height: "auto", display: "inherit", flexShrink: 1, flexGrow: 1}}>
                  <form
                    id="wbe-login"
                    action={this.state.action}
                    onSubmit={(event) => {
                      this.handleSubmit(event);
                    }}
                    method="post"
                    className="header-form"
                    style={{ marginLeft: "auto", marginRight: "auto", height: "auto", backgroundColor: "transparent"}}
                  >
                    <div
                      className="alert-message c-div-error"
                      style={{ textAlign: "center" }}
                    >
                      {this.state.errorMessage}
                    </div>
                    <div className="c-div">
                      <input
                        id="userName"
                        name="userName"
                        placeholder="Username..."
                        className="c-input header-form__input"
                        tabIndex="1"
                        required
                        onChange={(event) => {
                          this.updateUsername(event);
                        }}
                      />
                      <br />

                      <input
                        id="password"
                        name="password"
                        type="password"
                        placeholder="Password..."
                        className="c-input header-form__input"
                        required
                        tabIndex="2"
                        onChange={(event) => {
                          this.updatePassword(event);
                        }}
                      />

                      <div className="header-form__options header-form__options--1 t-label">
                        <label className="header-form__label">
                          <Checkbox
                            id="admin"
                            name="admin"
                            onChange={(event) => {
                              this.handleUpdate(event);
                            }}
                          />
                          <span>Admin</span>
                        </label>
                        <label
                          className="header-form__label"
                          style={{ whiteSpace: "nowrap" }}
                        >
                          <Checkbox name="rememberme" />
                          <span>Remember Me</span>
                        </label>
                        {this.renderHelpLabel()}
                      </div>

                      <div className="header-form__options header-form__options--2">
                        <label className="header-form__label header-form__link">
                          Forgot your&nbsp;<Link to="/forgotUsername">username</Link>
                          &nbsp;or&nbsp;<Link to="/forgotPassword">password</Link>
                          &nbsp;?
                        </label>
                      </div>
                      <button
                        type="submit"
                        className="c-btn c-btn--white header-form__btn"
                        tabIndex="3"
                      >
                        Login
                        <svg
                          viewBox="0 0 30.595 12.238"
                          width="24"
                          height="11"
                          fill="currentColor"
                          style={{ marginLeft: 5 }}
                        >
                          <g transform="translate(-5 -22)">
                            <path
                              d="M-822,1194.358a6.119,6.119,0,0,1,6.119-6.119,6.12,6.12,0,0,1,5.564,3.569h16.362l2.55,2.55-2.55,2.55h-1.53l-1.53-1.02-1.529,1.02h-1.53l-1.53-1.02-1.53,1.02h-1.02l-1.53-1.02-1.529,1.02h-3.1a6.12,6.12,0,0,1-5.564,3.569A6.119,6.119,0,0,1-822,1194.358Zm2.55,0a1.53,1.53,0,0,0,1.529,1.53,1.53,1.53,0,0,0,1.53-1.53,1.53,1.53,0,0,0-1.53-1.53A1.53,1.53,0,0,0-819.45,1194.358Z"
                              transform="translate(827 -1165.238)"
                            />
                          </g>
                        </svg>
                      </button>
                      <button
                        id="signupBtn"
                        className="c-btn header-form__btn"
                        type="button"
                        onClick={(e) => {
                          this.handleSignUp(e);
                        }}
                      >
                        Sign Up
                      </button>
                    </div>
                  </form>
                  {this.displayHelp()}
              </div>
              <div class="ws__lists" style={{ marginTop: 35, paddingLeft: 70, paddingRight: 50, display: "inherit", height: "auto", flexBasis: "33%", flexGrow: 1}}><ul class="t-ul"><li>Book over 30,000 accommodation, attractions, transportation providers across North America</li><li>Access to scarce inventory in and around America's National Parks</li><li>Flexible booking terms and 24/7 U.S. based customer support </li></ul></div>
            </div>
          </LoadingOverlay>
        </div>
      );
    }
  };

  renderATIConnectButton = () => {
    return (
      <div>
        {this.renderRedirect()}
        <LoadingOverlay active={this.state.isActive} spinner text="Loading...">
          <div className="header-form" style={{ marginTop: 50 }}>
            <a
              href="/wbe"
              className="c-btn t-link mt30"
              style={{ margin: "auto" }}
              onClick={(event) => {
                this.handleClick(event);
              }}
            >
              Back to ATI Connect
            </a>
          </div>
        </LoadingOverlay>
      </div>
    );
  };

  handleClick = (event) => {
    console.log("The link was clicked.");
    Cookies.remove("ATIWBESESSION", { path: "/" });
  };

  /**
   * Handles the form signup event.
   * @param {Event} event
   */
  handleSignUp(event) {
    redirectToSignup();
  }

  renderMainLogin = () => {
    let sessionCookie = Cookies.get("ATIWBESESSION");
    if (sessionCookie) {
      return this.renderATIConnectButton();
    } else {
      return (
        <div>
          {this.renderRedirect()}
          <LoadingOverlay
            active={this.state.isActive}
            spinner
            text="Loading..."
          >
            <form
              id="wbe-login"
              action={this.state.action}
              onSubmit={(event) => {
                this.handleSubmit(event);
              }}
              method="post"
              className="header-form"
              style={{ display: "inherit", height: "auto" }}
            >
              <div className="alert-message c-div-error">
                {this.state.errorMessage}
              </div>
              <div className="header-form__inner">
                <input
                  id="userName"
                  name="userName"
                  placeholder="Username..."
                  className="c-input header-form__input"
                  tabIndex="1"
                  required
                  onChange={(event) => {
                    this.updateUsername(event);
                  }}
                />
                <div className="header-form__options header-form__options--1 t-label">
                  <label className="header-form__label">
                    <Checkbox
                      id="admin"
                      name="admin"
                      onChange={(event) => {
                        this.handleUpdate(event);
                      }}
                    />
                    <span>Admin</span>
                  </label>
                  {this.renderHelpLabel()}
                </div>
                <input
                  id="password"
                  name="password"
                  type="password"
                  placeholder="Password..."
                  className="c-input header-form__input"
                  required
                  tabIndex="2"
                  onChange={(event) => {
                    this.updatePassword(event);
                  }}
                />
                <div className="header-form__options header-form__options--2">
                  <label
                    className="header-form__label"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    <Checkbox name="rememberme" />
                    <span>Remember Me</span>
                  </label>
                  <label className="header-form__label header-form__link">
                    Forgot your&nbsp;<Link to="/forgotUsername">username</Link>
                    &nbsp;or&nbsp;<Link to="/forgotPassword">password</Link>
                    &nbsp;?
                  </label>
                </div>
                <button
                  type="submit"
                  className="c-btn c-btn--white header-form__btn"
                  tabIndex="3"
                >
                  Login
                  <svg
                    viewBox="0 0 30.595 12.238"
                    width="24"
                    height="11"
                    fill="currentColor"
                    style={{ marginLeft: 5 }}
                  >
                    <g transform="translate(-5 -22)">
                      <path
                        d="M-822,1194.358a6.119,6.119,0,0,1,6.119-6.119,6.12,6.12,0,0,1,5.564,3.569h16.362l2.55,2.55-2.55,2.55h-1.53l-1.53-1.02-1.529,1.02h-1.53l-1.53-1.02-1.53,1.02h-1.02l-1.53-1.02-1.529,1.02h-3.1a6.12,6.12,0,0,1-5.564,3.569A6.119,6.119,0,0,1-822,1194.358Zm2.55,0a1.53,1.53,0,0,0,1.529,1.53,1.53,1.53,0,0,0,1.53-1.53,1.53,1.53,0,0,0-1.53-1.53A1.53,1.53,0,0,0-819.45,1194.358Z"
                        transform="translate(827 -1165.238)"
                      />
                    </g>
                  </svg>
                </button>
                <button
                  id="signupBtn"
                  className="c-btn header-form__btn main-signup-btn"
                  type="button"
                  onClick={(e) => {
                    this.handleSignUp(e);
                  }}
                >
                  Sign Up
                </button>
              </div>
            </form>
            {this.displayHelp()}
          </LoadingOverlay>
        </div>
      );
    }
  };

  render() {
    if (this.state.source === "login") {
      return this.rendorVertialLogin();
    } else {
      return this.renderMainLogin();
    }
  }
}

export default LoginATI;



// WEBPACK FOOTER //
// ./src/components/Auth/Login.js